export default __webpack_public_path__ + "static/media/Surya-hydraulics.a8a1b045.webp";